import React, { useContext } from 'react'
import FlatsyForm from '@flatsy/core/Form/Library/Form'
import FormSubmitButton from '@flatsy/core/Form/Global/Submit/Button'
import { LayoutSeparator } from '@flatsy/core/Layout/Separator/Layout'
import { ButtonSecondaryOutlined } from '@flatsy/core/MaterialUi/Button'
import { useDispatch } from 'react-redux'
import { saveApplicantInApplication } from 'src/redux/slices/Applicant/Action'
import { AppDispatch } from 'src/utils/AppDispatch'
import { flatsyErrorToFinalForm } from '@flatsy/utils/Functions/form/Errors'
import { unwrapResult } from '@reduxjs/toolkit'
import { FileContext } from '../../../Context'
import { useStyles } from './Style'

interface Information {
  first_name: string
  last_name: string
  phone_number: string
  email: string
}
const Form: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const dispatch: AppDispatch = useDispatch()
  const {
    applicationId,
    informationForm: { toggle },
    applicants: { current },
  } = useContext(FileContext)
  const informations: Information = {
    first_name: current?.first_name || '',
    last_name: current?.last_name || '',
    phone_number: current?.phone_number || '',
    email: current?.email || '',
  }

  const onSubmitUpdateInformation = async (
    newInformation: Information
  ): Promise<undefined | unknown> => {
    if (newInformation && applicationId && current?.id) {
      return dispatch(
        saveApplicantInApplication({
          ...newInformation,
          id: current.id,
          applicant_id: applicationId,
        })
      )
        .then((action) => {
          const r = unwrapResult(action)
          return r
        })
        .then(() => {
          toggle({
            open: false,
            userId: '',
          })
        })
        .catch(flatsyErrorToFinalForm)
    }
    return undefined
  }
  const handleClickCancel = (event: any) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    toggle({
      open: false,
      userId: '',
    })
  }

  const renderCustomButton = (_: boolean, disabled: boolean) => {
    return (
      <div className={classes.buttonsContainer}>
        <ButtonSecondaryOutlined className={classes.cancelButton} onClick={handleClickCancel}>
          Annuler
        </ButtonSecondaryOutlined>
        <FormSubmitButton className={classes.submitButton} type="submit" disabled={disabled}>
          Enregistrer
        </FormSubmitButton>
      </div>
    )
  }

  return (
    <div className={classes.container}>
      <FlatsyForm
        formData={informations}
        fields={[
          {
            type: 'text',
            name: 'first_name',
            label: 'Prénom',
            validation: 'validateNotEmptyOrUndefined',
            col: 6,
            colXs: 12,
          },
          {
            type: 'text',
            name: 'last_name',
            label: 'Nom',
            validation: 'validateNotEmptyOrUndefined',
            col: 6,
            colXs: 12,
          },
          {
            type: 'separator',
            name: 'separator1',
            label: '',
            components: <LayoutSeparator />,
          },
          {
            type: 'tel',
            name: 'phone_number',
            label: 'Téléphone',
            validation: 'validatePhoneNumber',
          },
          {
            type: 'text',
            name: 'email',
            label: 'Adresse email',
            validation: 'validateEmail',
          },
        ]}
        submitEvent={onSubmitUpdateInformation}
        submitText="Continuer"
        customButton={renderCustomButton}
        withSubmitDisabledAndCheckUpdate
      />
    </div>
  )
}

export default Form
